module.exports = __webpack_public_path__ + "img/data_box_area.f7f407d4.png";